import { ScrollArea, Tabs, TabsList, TabsTrigger } from '@ibsys/kit';
import { FC } from 'react';
import { useFlattenRoutes } from '@/shared/lib/ts-router/hooks/useFlattenRoutes';

export const SpotlightBodyBase: FC = () => {
  const routes = useFlattenRoutes();

  const filteredRoutes = routes.filter(({ path, icon }) => icon && path !== '/profile' && path !== '/users/list');

  return (
    <div className="flex flex-col gap-3 px-5 flex-1">
      <Tabs defaultValue={filteredRoutes[0].path} className={'overflow-hidden'}>
        <div className={'pb-2 flex flex-col gap-3 w-full'}>
          <ScrollArea className={'w-full overflow-hidden rounded-lg -pb-1.5'} classNames={{ horizontalBar: 'h-1.5' }}>
            <TabsList>
              {filteredRoutes.map((route) => (
                <TabsTrigger value={route.path} key={route.path}>
                  {route.label}
                </TabsTrigger>
              ))}
            </TabsList>
          </ScrollArea>
          <ScrollArea orientation={'vertical'}></ScrollArea>
        </div>
      </Tabs>
    </div>
  );
};
